
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { buildingGroups } from './BuildingGroups'
import { buildingFloorPlans } from './BuildingFloorPlans'

var NewBuilding = Class.create({
    buildingGroups: null,
	buildingFloorPlans: null,
	buildingTemplates: null,
  	initialize: function() {
  		// #  Store our id of the current seleected floor plan
  		this.floorPlanID = null;
  		this.numLevels = null;
  		this.buildingTemplateID = null;
		this.totalSpace = 0;
		this.server = server;
  		// #  Store our buildingTemplate Handlebars ID
  		this.buildingTemplateHandleBarsID = "addbuilding-building-template-handlebars";
  		this.buildingTemplateContainerID = "template_options";
  		// Call server for our data
		// #  Localize this instance for use on success
		/*var self = this;
		// prepare our data to be sent
		var url = "app/server/service.php";
		//var params = {'action': 'getBuildingGroupsSingle', 'columnName': 'building_group_name','module' : 'Building_groups'};
		var params = {'action': 'getAllBuildingInfo','module' : 'Addbuilding'};

		// #  Send to server object for processing
		var data = this.overviewObject.server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.status == 1 || response.status == 2)
			{
			}
			else
			{
				// Lets attach our users level limit to the data for populating
				response.data.building_level_limit = self.overviewObject.userObject.userInfo.level_limit;
				// Process our script now
				self.overviewObject.sendTemplateWithAnimations(self.overviewObject.addBuildingContianer,self.overviewObject.addBuildingHandlebars,response.data,"inner-Overview","addBuildingSection","drop");
				// #  We need to loop through each floor_plan to render the 3d model 
				// #  Process our 3d floor plans
				for(var i = 0; i < response.data.floor_plans.length;i++)
				{
					self.floorPlan3D.createMini3DModel(response.data.floor_plans[i].id,response.data.floor_plans[i].step_size,response.data.floor_plans[i].grid_size,response.data.floor_plans[i].floor_plan_model);
				}
				// #  fires the action listener for going back to last view
				self.overviewObject.initActionListenersAddBuilding();
				// #  Fire our init listenrs
				self.initActionListeners();
			}
		})
		.fail(function(e){
			console.log(e);
        });*/
        var self = this;
        buildingGroups.getBuildingGroupsCallback(function(groupData){
            self.buildingGroups = groupData;
			// Get floor plan data
			buildingFloorPlans.getFloorPlansCallback(function(floorPlanData){
				self.buildingFloorPlans = floorPlanData;
			});
        });
  	},
  	initActionListeners: function() {
  		// #  Send to step two
  		jQuery('.thumbnail .floor_plan_modal').on('click',this.moveStepOne.bind(this));
  		// #  Sends to step three
  		jQuery('#building_level_select').on('change',this.moveStepTwo.bind(this));
  		// #  Bind our step buttons, in the case of moving forward and backwards
  		jQuery('.step-label').on('click',this.moveToAStep.bind(this));
  		// #  Hook up function to process our data for saving to server
  		jQuery('#save-building').on('click',this.saveBuilding.bind(this));
  	},
  	// #  We use this to change view to another step
  	moveToAStep: function(e) {
  		var target = e.currentTarget;
  		target = jQuery(target).parent().next();
  		// #  Slide Up steps
  		jQuery(".slide-view").slideUp("slow");
  		// #  Slide down the selected step
  		target.slideDown("slow");
  	},
  	moveStepOne: function(e) {
  		e.preventDefault();
  		// #  Remove old active selected thumbnail
  		jQuery(".thumbnail.active").removeClass('active');
  		// #  Toggle active on selected floor plan
  		var target = e.currentTarget;
  		target = jQuery(target).parent().addClass('active');
  		// #  Toggle steps
  		jQuery(".floor_option").slideUp("slow");
  		jQuery(".step-two").show("slow");
  		jQuery(".building_levels").show("slow");
  		// #  Setup our input box with the selected ID
  		var selectedID = e.currentTarget.id;
  		jQuery("#floor_plan").val(selectedID);
  		// #  Store into our addbuilding object
  		this.floorPlanID = selectedID;
  		// #  Lets see if a level was already selected, if so, call server to populate templates
  		if(this.numLevels !== null)
  			this.getBuildingTemplates(this.floorPlanID,this.numLevels);

  	},
  	moveStepTwo: function(e){
  		jQuery(".building_levels").slideUp("slow");
  		jQuery(".step-three").show("slow");
  		jQuery(".template_option").show("slow");
  		// #  Setup our level input box with the amount of levels selected
    	var valueSelected = e.currentTarget.selectedOptions[0].value;
  		jQuery("#building_level").val(valueSelected);
  		// #  Store into our addbuilding object
  		this.numLevels = valueSelected;
 		// #  Send to server to get the latest building templates
  		this.getBuildingTemplates(this.floorPlanID,this.numLevels);
  	},
  	getBuildingTemplates: function(floorPlanID, levelAmount, callback = null) {
		var self = this;

		var url = "buildings/templates/" + floorPlanID;
		var params = {
			'levelLimit': levelAmount
		}
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			if(callback) {
				callback(response.data);
			}

			self.buildingTemplates = response.data;
		})
		.fail(function(e){
			console.log(e);
		});
  	},
  	// #  When a building template is selected
  	buildingTemplateSelected: function(e) {
  		// #  Stop a href from processing
  		e.preventDefault();
  		// #  Localize variable
  		var self = this;
  		// #  Remove old active selected thumbnail
  		jQuery(".thumbnail.active-template").removeClass('active-template');
  		// #  Toggle active on selected floor plan
  		var target = e.currentTarget;
  		target = jQuery(target).parent().addClass('active-template');
  		// #  Setup our input box with the selected ID
  		var selectedID = e.currentTarget.id;
  		jQuery("#building_templates").val(selectedID);
  		// #  Store into our addbuilding object
  		self.buildingTemplateID = selectedID;
  		// #  Add up all of our level spaces
  		// #  Reset total spaces
  		self.totalSpace = 0;
  		jQuery(e.currentTarget).find(".total-level-space").each(function(){
  			self.totalSpace += parseInt(jQuery(this).text());
  		});
  		// #  Lets hide our step 3 select option
  		jQuery(".template_option").slideUp("slow");
  		// #  Show our save building button
  		jQuery('.create-building').show('slow');
  	},
  	saveBuilding: function(context) {
		var self = this;
		// prepare our data to be sent
		var url = "buildings/new";
		var params = context.state;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				context.setState({saved: true})
				modal.showInfo("New building was added!", "success", "top", "center");
				browserHistory.goBack();
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
  	},
  	// #  Use this to attach mainly for the template options
  	initSlimScrollCustom: function(attachDom,height,width) {
		// #  We need to setup our slimScroll on our editing window
		jQuery(attachDom).slimScroll({
        	height: height,
			width: width
		});
	},
  	build3DFloorPlans: function(data) {
 
  	}
});

export let newBuilding = new NewBuilding();


// WEBPACK FOOTER //
// app/core/controllers/NewBuilding.js